var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBannerError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 26L16 5.5L28 26H4ZM7.76364 23.8421H24.2364L16 9.81579L7.76364 23.8421ZM16 22.7632C16.3091 22.7632 16.5682 22.6598 16.7773 22.453C16.9864 22.2462 17.0909 21.9899 17.0909 21.6842C17.0909 21.3785 16.9864 21.1223 16.7773 20.9155C16.5682 20.7087 16.3091 20.6053 16 20.6053C15.6909 20.6053 15.4318 20.7087 15.2227 20.9155C15.0136 21.1223 14.9091 21.3785 14.9091 21.6842C14.9091 21.9899 15.0136 22.2462 15.2227 22.453C15.4318 22.6598 15.6909 22.7632 16 22.7632ZM14.9091 19.5263H17.0909V14.1316H14.9091V19.5263Z",
    fill: "#BF1722"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBannerError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/banner-error.0ebd9938c92f01676c97c71c884f6c39.svg";